module.exports = {
      id: "fb-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#fb",
      toString: function () {
        return this.url;
      }
    }